import React from "react";
import styles from "./pages.module.css";

import { PasswordResetForm } from "../comonents/Forms/PasswordResetForm"

export const PasswordReset = (props) => {

    // ----------------------------------------------------- STATE AND HOOKS
    // ----------------------------------------------------- PRE-RENDER
    // ----------------------------------------------------- RENDER

    return (
        <section className={styles.container}>
            <div className={styles.content}>
               <PasswordResetForm />
            </div>
        </section>
    )
}